import { apiService } from './index';
import { IConfigTimeFrame, IConfigWeCallYou } from '../shared/types/weCallYou';

export const asyncGetWeCallYouConfig = async () => {
    return await apiService.get('/api/we-call-you-config');
};

export const asyncPostConfigWeCallYou = async (
    formConfigWeCallYou: IConfigWeCallYou
) => {
    return await apiService.post(
        '/api/we-call-you-config',
        formConfigWeCallYou
    );
};

export const asyncGetWeCallYouConfigTimeFrame = async (
    page?: number,
    pageSize?: number
) => {
    return await apiService.get('/api/we-call-you-config/time-frame', {
        limit: pageSize || 20,
        page: page || 0,
    });
};

export const asyncPostConfigTimeFrame = async (
    formConfigTimeFrame: IConfigTimeFrame
) => {
    return await apiService.post(
        '/api/we-call-you-config/time-frame',
        formConfigTimeFrame
    );
};

export const asyncDeleteConfigTimeFrame = async (id: string) => {
    return await apiService.delete(`/api/we-call-you-config/time-frame/${id}`);
};

export const asyncGetFrimeTime = async (id: string) => {
    return await apiService.get(`/api/we-call-you-config/time-frame/${id}`);
};

export const asyncPatchtFrimeTime = async (id: string, formFrimeTime: any) => {
    return await apiService.put(
        `/api/we-call-you-config/time-frame/${id}`,
        formFrimeTime
    );
};

export const asyncGetAvaibleFrimeTime = async (date: string) => {
    return await apiService.get(
        '/api/we-call-you-config/time-frame/available',
        {
            date: date,
        }
    );
};
